import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FMessageDialogComponent } from '../f-message-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class FMessageDialogService {

  constructor(
    private _dialog: MatDialog,
  ) { }

  public open(dialog_data: FMessageDialogDataInterface, disableClose: boolean = false) {
    return this._dialog.open(FMessageDialogComponent, { data: { ...dialog_data }, disableClose });
  }
}

export interface FMessageDialogDataInterface {
  title: string;
  type: 'success' | 'danger' | 'warning' | 'info' | 'secondary' | 'primary';
  message: string | string[] | {
    message: string,
    style?: string | null
    tag?: 'a' | 'p' | null,
    href?: string | null,
  }[];
  onClose?: () => void;
}